var Locale;
(function (Locale) {
    Locale["RU"] = "ru";
    Locale["EN"] = "en";
})(Locale || (Locale = {}));

export { Locale };
